import {
  Component,
  Injectable,
  OnInit,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  Input,
} from "@angular/core";
import {
  NgbDateStruct,
  NgbCalendar,
  NgbCalendarIslamicUmalqura,
  NgbDatepickerI18n,
} from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { IDate } from "../../models/models";
@Component({
  selector: "app-datepicker-gregorian",
  templateUrl: "./datepicker-gregorian.component.html",
  styleUrls: ["./datepicker-gregorian.component.scss"],
  outputs: ["onDateSelect"],
})
export class DatepickerGregorianComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    if (
      this.dateValue &&
      this.dateValue.year &&
      this.dateValue.month &&
      this.dateValue.day
    )
      this.form.controls["date"].setValue(this.dateValue);
  }

  model: NgbDateStruct;
  public onDateSelect = new EventEmitter();
  today = this.calendar.getToday();

  @Input() minDate: NgbDateStruct = { day: 1, month: 1, year: 1900 };
  @Input() maxDate: NgbDateStruct = { day: 31, month: 12, year: 2077 };
  @Input() isRequired: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() displayFooter: boolean = false;
  @Input() label: string;
  @Input() placeHolder: string = "yyyy-mm-dd";
  @Input() showIsRequiredSpan: boolean = false;

  @Input() value: IDate;
  private dateValue: NgbDateStruct;

  form: FormGroup = new FormGroup({
    date: new FormControl(""),
  });

  constructor(
    private calendar: NgbCalendar,
    private translate: TranslateService
  ) {
    if (this.isRequired)
      this.form.controls["date"].setValidators(Validators.required);
  }

  ngOnInit(): void {
    if (this.value && this.value.day && this.value.month && this.value.year) {
      this.dateValue = {
        day: parseInt(this.value.day),
        month: parseInt(this.value.month),
        year: parseInt(this.value.year),
      } as NgbDateStruct;
    }
  }

  public isFormValid(): boolean {
    var isValid = true;
    if (this.isRequired) {
      if (
        !this.form.controls["date"].value ||
        !this.form.controls["date"].value.day ||
        !this.form.controls["date"].value.month ||
        !this.form.controls["date"].value.year
      ) {
        isValid = false;
        for (let control in this.form.controls) {
          this.form.controls[control].markAsTouched();
        }
      }
    }

    return isValid;
  }

  selectToday() {
    this.model = this.calendar.getToday();
  }

  selectDate() {
    if (
      this.form.controls["date"].value &&
      this.form.controls["date"].value.day &&
      this.form.controls["date"].value.month &&
      this.form.controls["date"].value.year
    ) {
      //this.form.reset()
      this.onDateSelect.emit({
        value: this.form.controls["date"].value,
      });
    }
  }

  click() {
    // if (this.form && this.form.length) {
    //     for (let i = 0; i < this.form.length; i++) {
    //         if (this.form[i]) {
    //             this.form[i].datePicker.close()
    //         }
    //     }
    // }
    // this.datePicker.toggle()
    // this.onClick.emit({})
  }
  resetDate() {
    this.form.controls["date"].setValue(null);
    this.form.reset();
  }
}
